/*

poornima 09/19/2022  2701012930  Fixed GAL-127,132,73,60,104 bugs.
poornima 09/19/2022  2701012930  Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs.
poornima 09/20/2022  2701012930  Fixed GAL-127,131,166,171 bugs.
dilip 10/10/2022  2701012930  visbility icon changed to Datausage.
dilip 10/10/2022  2701012930  changed Visibility To Datausage icon.
Ravi 10/10/2022  2701012930  fixed sorting issue in BRE.
saiKrishna 10/12/2022  2701012930  Print_Payload_changes ,FormulaRuleGroup_payload.
ashraf 10/13/2022  2701012930  fixed filter and formula rule group, communication history bug fixes.
sohel 10/15/2022  2701012930  Triggers ->Added Code Comments.
Suresh peddavoora 10/26/2022  2701012930 Added outlined Icons in Actions Columns.
Suresh peddavoora 10/27/2022  2701012930 Changed Button Positions from table header to footer.
akhila 10/27/2022 2701012930  bre UX Changes
Ashraf 10/30/2022 2701012930  Added conditional button renders
Ashraf 10/30/2022 2701012930  removed search bar
Dilip  31/10/2022 2701012930  added clickable link functionality to Rule Group code
Ashraf 11/01/2022 2701012930 renamed button labels
Ashraf 11/01/2022 2701012930 disabled download buttons when there are no records
lalitha 11/01/2022 2701012930 added span element in column link
saikrishna 11/03/2022 2701012930 changed the paginationOptions
Lalitha 11/03/2022 2701012930 changed button Name and column titles
Dilip 11/03/2022 2701012930 Added rule group in delete popup
Dilip 11/04/2022 2701012930 Changed message in delete popup
Sohel 11/05/2022 2701012930 rename download configurations
Sohel 11/09/2022 2701012930  prepoulate Filter code.
Dilip 11/14/2022 2701012930  Enable delete usage popup
Ashraf 11/14/2022 2701012930 fixed bre role issue
Sohel 11/16/2022 2700912712 reset get data
Sohel 11/17/2022 2700912712 Added System Notes functionality
Sohel 11/17/2022 2700912712 Implemented Copy Functionality
lalitha 11/17/2022 2700912712 Added status column in table
Sohel 11/19/2022 2700912712 fixed Delete Toast issue
Sohel 11/22/2022 2700912712 System notes added add notes button
Suresh Peddavoora 12/01/2022 2700912712 Added ClassName for Draft Status and Removed Inline Styles
Sohel 12/04/2022 2700912712 fixed Global Field List reset Issue
Sohel 12/04/2022 2700912712 Delete Usage Label Changes
Sohel  12/05/2022 2700271704 Added Edit Icon and border to code
lalitha 12/07/2022 2700271704 added Created By payload
akhila 12/08/2022 2700271704 adding session storage for search items
Saikrishna 12/08/2022 2698948956 Removed name fields.
lalitha 12/09/2022 2698948956 Added Created Date column and payload
Ashraf 12/14/2022 2698948956 fixed role access
lalitha 15/12/2022 2698948956 added access role in filter rule group
Sohel 12/16/2022 2698948956 map Fields changes
akhila 12/20/2022 2698948956 fixed filter uppercase issue
akhila 12/20/2022 2698948956 changed label for usage
akhila 12/26/2022 2698948956 changed sourceType Payload
Raghu 12/26/2022 2698948956  Added Dialog Component
sai krisha 30/12/2022 2698948956 add code description values
Ashraf 01/02/2023 2698948956 renamed usage header title
Akhila 01/10/2023 2698948956 Updated the payload in download configuration
Dilip 01/10/2023 2698948956 Updated the payload in download configuration usage
Dilip 01/17/2023 2698948956 fixed checkbox issue
Akhila 01/30/2023 2698948956 Rename Dialog box title and tooltip
Dilip 02/13/2023 2698948956 created by payload changes
Raghu 02/21/2023 2698948956 changed new button styles
Ravi 02//24/2023 2698948956 Added popup in download configuration button
Dilip 02/28/2023 2698948956 Fixed Sorting issue
Dilip 02/28/2023 2698948956 payload changes
Akhila 03/01/2023 2698948956 Added loader and download toast message for preview File
Rohini 03/14/2023 2698948956 fixed the responsive in tab
Suresh Peddavoora 03/15/2023 2698948956 Added Dropdown menu in Action Column in table
Suresh Peddavoora 03/16/2023 2698948956 Added test menu in Action Column in table
Raghu 04/04/2023 2698948956 added add icon
suresh peddavoora 04/06/2023 2698948956 fields alignments fixes
Prakash 07-04-23 2698811066 fixed alignment issue in tab view.
Sohel 04/12/2023 2698811066 Fixed Filter Rule check Box Issue
Sohel 05/08/2023 2698948956 Fixed Rule Group Code Prepopulate Issue
Ravi 05/31/2023 2698948956 changed delete popup message
Akhila 06/07/2023 2698948956 added breadcrum code and description
Akhila 06/08/2023 2698948956 created date change to date created field and column
Akhila 06/12/2023  2698948956 session storage bug fix in filter dashboard
Akhila 06/13/2023 2698948956 session stoarage table issue fix
*/

import React, {createRef, useEffect, useState, useRef} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {
  resetMessage,
  fetchError,
  usageRuleGroup,
  printFilterRuleGroup,
  resetRuleGroupPrintStatus,
  fetchDeleteSuccess,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import OverrideRule from '../../../../../components/OverrideRule';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {makeStyles} from '@material-ui/core';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import UsageMessage from '../../../../../util/UsageMessage';
import {
  resetFilterRuleGroupData,
  fetchFilterRuleGroup,
  resetCopyFilter,
} from '../../../../../redux/reducers/BRE/FilterRuleGroup';
import DialogBox from '../../../../../components/DialogBox/index';
import FilterNotes from './FilterNotes';
import CopyFilter from './CopyFilter';
import {systemNotesResetToast} from '../../../../../redux/reducers/BRE/SystemNotes';
import {resetGlobalFieldList} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import moment from 'moment';
import {downloadButton} from '../../../../../util/Content';
import {fetchCreatedByDropDownData} from '../../../../../redux/reducers/ReportMaster';
import axios from 'axios';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';

import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
import AddIcon from '@material-ui/icons/AddOutlined';
const useStyles = makeStyles((theme) => ({
  'link': {
    // Changed field list code column font color (2700799562)
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));
export default function RuleGroupSearchTable({
  setValue,
  searchData,
  setBreCode,
  submit,
  setResetData,
  setSubmit,
  dataReset,
  setRowData,
  roleDataBre,
  passValues,
  handleClose,
  setUsage,
  setDeleteUsage,
  userMetrixDelete,
  isDelete,
  setIsDelete,
  isUsage,
  setIsUsage,
  setRowSelected,
  setShowFilterData,
  setUserMetrixDelete,
  StepperFilter,
  setIsCopy,
  ruleGroupCode,
  setRuleGroupCode,
  setGroupId,
  setRuleGroupId,
}) {
  const {searchRuleGroupFieldData} = useSelector(({addEventTactic}) => addEventTactic);
  const {
    successMsg,
    errorMsg,
    isLoading,
    ruleGroupPrintStatus,
    usageFilterRuleGroupData,
    configurationUrl,
    dockey,
  } = useSelector(({addRuleGroup}) => addRuleGroup);
  const {copyFilterStatus, copySuccessMsg, copyErrorMsg, copyCode} = useSelector(
    ({addFilterRuleGroup}) => addFilterRuleGroup,
  );
  const [isNote, setIsNote] = useState(false);
  const [filterData, setFilterData] = useState();
  const [copyFilter, setCopyFilter] = useState(false);
  const [oldFilterCode, setOldFilterCode] = useState('');
  const [codeAndDescription, setCodeAndDescription] = useState({});
  // const [checked, setChecked] = useState();
  const classes1 = useStyles();
  // const [code, setCode] = useState(ruleGroupCode);
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  // const handleSelectionProps = (rowData) => {
  //   return {
  //     disabled: !!(checked && checked.length >= maxSelections && !rowData.tableData.checked),
  //   };
  // };
  const columns = [
    {
      title: 'Filter Name',
      field: 'code',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            !StepperFilter && setRowSelected(true);
            if (
              Object.keys(searchRuleGroupFieldData).length > 0 &&
              searchRuleGroupFieldData.status
            ) {
              searchRuleGroupFieldData.setFieldValue(
                searchRuleGroupFieldData.fieldName,
                rowData.code,
              );
              searchRuleGroupFieldData.setShowSearch(false);
            } else if (handleClose) {
              dispatch(fetchFilterRuleGroup(rowData.groupId));
              handleClose();
            } else if (StepperFilter) {
              setShowFilterData(true);
              setIsCopy(false);
              dispatch(fetchFilterRuleGroup(rowData?.groupId));
            } else {
              dispatch(fetchFilterRuleGroup(rowData.groupId));
              setValue(1);
              setBreCode(rowData.code);
            }
          }}
        >
          {rowData?.code?.replace(/ /g, '\u00a0')}
        </span>
      ),
    },
    // {
    //   title: "Filter Name",
    //   field: "displayName",
    // },
    {
      title: 'Filter Description',
      field: 'description',
      width: '25%',
      headerStyle: {
        textAlign: 'left',
        fontSize: 16,
      },
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.description?.replace(/ /g, '\u00a0')}
          </div>
        </>
      ),
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="draft-status status">
            <span>Draft</span>
          </div>
        ) : (
          <div className="completed-status status">
            <span>Completed</span>
          </div>
        ),
    },
  ];
  const [countTotal, setCountTotal] = useState(null);
  const tableRef = createRef();
  const queryRef = useRef(null);
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [deleteWindowData, setDeleteWindow] = useState('');
  const [status, setStatus] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const filterRuleRoleAccess = roleData?.window?.['Filter Rules']?.['FR'];

  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  useEffect(() => {
    if (tableRef?.current && submit) {
      tableRef.current.onQueryChange();
    }
  }, [ruleGroupCode]);
  useEffect(() => {
    if (status) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('datacalculation'));
      setStatus(false);
    }
  }, [status]);
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit, searchData]);
  const {systemerrorMsg, systemsuccessMsg} = useSelector(({systemNotes}) => systemNotes);
  useEffect(() => {
    dataReset && setResetData(null);
  }, []);
  useEffect(() => {
    if (ruleGroupPrintStatus && ruleGroupPrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetRuleGroupPrintStatus());
      }, 2000);
    }
  }, [ruleGroupPrintStatus]);
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);

  useEffect(() => {
    dispatch(resetFilterRuleGroupData());
    dispatch(resetGlobalFieldList());
  }, []);

  useEffect(() => {
    if (copyFilterStatus === 200) {
      setTimeout(() => {
        dispatch(fetchFilterRuleGroup(copyCode));
        dispatch(resetCopyFilter());
        setValue(1);
        setCopyFilter(false);
      }, 2500);
    }
  }, [copyFilterStatus]);
  useEffect(() => {
    if (copyErrorMsg || copySuccessMsg) {
      setTimeout(() => {
        dispatch(resetCopyFilter());
      }, 2500);
    }
  }, [copyErrorMsg, copySuccessMsg]);
  const handleDelete = (rowData) => {
    setDeleteWindow(rowData);
    dispatch(usageRuleGroup(rowData.groupId));
    setIsDelete(false);
    setDeleteUsage(true);
    // handleDelete(rowData);
  };
  const handleEdit = (rowData) => {
    setRowSelected(true);
    if (Object.keys(searchRuleGroupFieldData).length > 0 && searchRuleGroupFieldData.status) {
      searchRuleGroupFieldData.setFieldValue(searchRuleGroupFieldData.fieldName, rowData.code);
      searchRuleGroupFieldData.setShowSearch(false);
    } else if (handleClose) {
      dispatch(fetchFilterRuleGroup(rowData.groupId));
      handleClose();
    } else {
      dispatch(fetchFilterRuleGroup(rowData.groupId));
      setValue(1);
      setBreCode(rowData.code);
    }
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setFilterData(rowData);
  };
  const handleCopy = (rowData) => {
    if (StepperFilter) {
      setIsCopy(true);
      setShowFilterData(true);
      dispatch(fetchFilterRuleGroup(rowData?.groupId));
    } else {
      setCopyFilter(true);
      setOldFilterCode(rowData?.code);
      setCodeAndDescription(rowData);
    }
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setRowData(rowData);
    dispatch(usageRuleGroup(rowData.groupId));
  };
  const handleDialogClose = () => {
    setIsDelete(false);
    setTimeout(() => {
      setUserMetrixDelete(false);
    }, 1000);
  };
  // useEffect(() => {
  //   if (tableRef?.current && code) {
  //     tableRef.current.onQueryChange();
  //   }
  // }, [code, ruleGroupCode]);

  // useEffect(() => {
  //   if (ruleGroupCode) {
  //     setCode(ruleGroupCode);
  //   }
  // }, [ruleGroupCode]);
  const handleCopyFilter = () => {
    setCopyFilter(false);
  };
  const handleDeleteSubmission = () => {
    setStatus(true);
    new Promise((resolve, reject) => {
      httpPaginationDelete(`rules/delete/filterrulegroup/${deleteWindowData.groupId}`)
        .then((response) => {
          if (response?.data?.status === 400) {
            dispatch(fetchError(response));
            setStatus(false);
            handleDialogClose();
            setTimeout(() => {
              dispatch(resetMessage());
            }, 2000);
          }
          if (response?.status === 200) {
            resolve();
            setStatus(false);
            dispatch(fetchDeleteSuccess(response));
            handleDialogClose();
            setTimeout(() => {
              dispatch(resetMessage());
            }, 2000);
          } else {
            reject(new Error());
            setStatus(false);
            dispatch(fetchError(response));
            handleDialogClose();
            setTimeout(() => {
              dispatch(resetMessage());
            }, 2000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  };
  const handleCloseDialog = () => {
    setIsNote(false);
  };
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  const handleSubmit = () => {
    //  userMetrixDelete ? setValue(2) : handleDeleteSubmission();
    if (isDelete && userMetrixDelete) {
      // setFieldRowData(deleteRowInfo);
      // setValue(2);
      setIsUsage(true);
      setIsDelete(false);
      setTimeout(() => {
        setUserMetrixDelete(false);
      }, 1000);
    } else {
      handleDeleteSubmission();
    }
  };

  useEffect(() => {
    if (systemerrorMsg || systemsuccessMsg) {
      setTimeout(() => {
        dispatch(systemNotesResetToast());
      }, 1500);
    }
  }, [systemerrorMsg, systemsuccessMsg]);
  // useEffect(() => {
  //   if (tableRef?.current && !ruleGroupCode) {
  //     tableRef.current.onQueryChange();
  //     setChecked([]);
  //   }
  // }, [ruleGroupCode]);

  // useEffect(() => {
  //   if (ruleGroupCode) setChecked([{ ruleGroupCode: ruleGroupCode }]);
  // }, [ruleGroupCode]);

  const SearchSessionFilterRules = JSON.parse(sessionStorage.getItem('FilterRules'));
  if (SearchSessionFilterRules && !StepperFilter && !submit) {
    searchData = SearchSessionFilterRules;
  }
  // useEffect(() => {
  //   if (tableRef?.current && !StepperFilter) {
  //     tableRef.current.onQueryChange();
  //   }
  // }, [searchData]);

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDialogClose}
        title="Delete Filter Rule"
        value={
          userMetrixDelete ? (
            <UsageMessage value={'Filter Rule'} />
          ) : (
            `Are you sure you want to delete the ${deleteWindowData?.code} Filter Rule ?`
          )
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleSubmit}
      />
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Filter Rules'}
      />
      <DialogBox
        open={copyFilter}
        dialogClose={handleCopyFilter}
        title="Copy Filter Rule "
        maxWidth="md"
        hideFooter={true}
      >
        <CopyFilter oldFilterCode={oldFilterCode} codeAndDescription={codeAndDescription} />
      </DialogBox>
      <OverrideRule
        dialogTitle="Filter Rule Usage"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title={`This Filter Rule has been used in the following places.`}
        data={usageFilterRuleGroupData?.placeResponse}
        isOverRide={false}
      />
      <DialogBox
        open={isNote}
        dialogClose={handleCloseDialog}
        title="Filter Rules Notes"
        maxWidth="lg"
      >
        <FilterNotes filterData={filterData} filterRuleRoleAccess={filterRuleRoleAccess} />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields actions-dropdown-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows) => {
              // setChecked(rows);
              setRuleGroupCode(rows[0]?.code ? rows[0]?.code : '');
              setGroupId(rows[0]?.groupId ? rows[0]?.groupId : '')
              setRuleGroupId(rows[0]?.groupId);
            }}
            data={(query) =>
              new Promise((resolve) => {
                const url = `rules/search/all`;
                const bodyObj = {
                  code: searchData?.code ? searchData.code : '',
                  displayName: searchData?.displayName ? searchData?.displayName : '',
                  description: searchData?.description ? searchData.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  returnType: searchData?.returnType ? searchData.returnType : '',
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                  ruleType: 'FilterRuleGroup',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;
                        const newData =
                          data?.length > 0 ?
                            data?.map((i) => {
                              if (i?.code?.toUpperCase() === ruleGroupCode?.toUpperCase()) {
                                setRuleGroupId(i?.groupId);
                                setGroupId(i?.groupId)
                                return {
                                  ...i,
                                  tableData: {checked: true},
                                };
                              } else {
                                return {
                                  ...i,
                                };
                              }
                            }) :
                            [];
                        resolve({
                          data: ruleGroupCode ? newData : data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setCountTotal(response.data.response.count);
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              selection: StepperFilter,
              showTextRowsSelected: false,
              emptyRowsWhenPaging: false,
              selectionProps: (rowData) => ({
                disabled: !rowData.tableData.checked && ruleGroupCode,
              }),
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={
              !handleClose && [
                {
                  icon: () => <SaveIcon />,
                  tooltip: 'Save User',
                  onClick: (event, rowData) => console.log(rowData, 'rowData'),
                },
              ]
            }
            components={{
              Pagination: (props) => (
                <div>
                  <div className="my-2">
                    {!handleClose && !StepperFilter && (
                      <>
                        <Button
                          type="button"
                          variant="outlined"
                          className={`mx-1 search-btn`}
                          disabled={Boolean(countTotal === 0)}
                          onClick={(event) => {
                            dispatch(
                              postPrintUsage({
                                baseCategory: '',
                                code: searchData?.code ? searchData.code : '',
                                description: searchData?.description ? searchData.description : '',
                                displayName: searchData?.displayName ? searchData?.displayName : '',
                                fileType: '',
                                recordFormatType: '',
                                returnType: searchData?.returnType ? searchData.returnType : '',
                                sourceType: 'FILTER RULE',
                                search: '',
                                frameworkUsageOrderBy: '',
                                frameworkUsageOrderDerection: '',
                                fieldListOrderBy:
                                  queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                    queryRef.current.orderBy.field :
                                    '',
                                fieldListOrderDerection: queryRef.current?.orderDirection ?
                                  queryRef.current?.orderDirection :
                                  '',
                                category: '',
                                fieldName: '',
                                isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                                repositoryDescription: '',
                                repositoryName: '',
                                repositoryType: '',
                                createdBy: searchData?.createdBy?.userLoginName ?
                                  searchData?.createdBy?.userLoginName :
                                  '',
                                createdDate: searchData?.createdDate ?
                                  moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                  '',
                              }),
                            );
                          }}
                        >
                          Download Configuration Usage
                        </Button>
                        <Button
                          type="button"
                          variant="outlined"
                          className={`mx-1 search-btn`}
                          disabled={Boolean(countTotal === 0)}
                          // tooltip: "Print",
                          // isFreeAction: true,
                          onClick={(event) => {
                            dispatch(
                              printFilterRuleGroup({
                                code: searchData?.code ? searchData.code : '',
                                displayName: searchData?.displayName ? searchData?.displayName : '',
                                description: searchData?.description ? searchData.description : '',
                                returnType: searchData?.returnType ? searchData.returnType : '',
                                ruleType: 'FilterRuleGroup',
                                orderBy:
                                  queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                    queryRef.current.orderBy.field :
                                    '',
                                orderDirection: queryRef.current?.orderDirection ?
                                  queryRef.current?.orderDirection :
                                  '',
                                isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                                createdBy: searchData?.createdBy?.userLoginName ?
                                  searchData?.createdBy?.userLoginName :
                                  '',
                                createdDate: searchData?.createdDate ?
                                  moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                  '',
                                filterRuleGroupId:""
                              }),
                            );
                          }}
                        >
                          {downloadButton}
                        </Button>
                      </>
                    )}
                  </div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleUsage={handleUsage}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: StepperFilter,
                    run: true,
                    copy: false,
                    hiddenDelete: StepperFilter,
                    notes: StepperFilter,
                    execution: true,
                    usage: false,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: !filterRuleRoleAccess?.edit,
                    disableRun: false,
                    disableCopy: handleClose || !filterRuleRoleAccess?.add,
                    disableDelete: !filterRuleRoleAccess?.delete,
                    disableExecution: false,
                    disableUsage: false,
                    disableNotes: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {
                      <Button
                        type="button"
                        variant="outlisetOpenned"
                        className={`mx-1 search-btn`}
                        disabled={!filterRuleRoleAccess?.add}
                        isFreeAction={true}
                        onClick={(event) => {
                          if (StepperFilter) {
                            setShowFilterData(true);
                          } else {
                            setValue(1);
                          }
                        }}
                        startIcon={<AddIcon />}
                      >
                        Add Filter Rule
                      </Button>
                    }
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </Grid>
      {(isLoading || printUsageIsLoading || isLoadingPrint) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg || copyErrorMsg || systemerrorMsg) && (
        <ErrorSnackbar
          errorMsg={errorMsg || printUsageErrorMsg || copyErrorMsg || systemerrorMsg}
        />
      )}
      {(successMsg || printUsageSuccessMsg || copySuccessMsg || systemsuccessMsg) && (
        <SuccessSnackbar
          successMsg={successMsg || printUsageSuccessMsg || copySuccessMsg || systemsuccessMsg}
        />
      )}
    </>
  );
}
